<template>
  <div class="enter-wrap">
    <v-layout justify-center column>
      <v-flex>
        <h1 class="display-36 primary--text text-center">כניסת מועמדים</h1>
      </v-flex>
      <v-flex>
        <DropDivider style="width: 100%" />
      </v-flex>
    </v-layout>
    <v-layout class="tabs-wraper pb-3">
      <v-flex class="tabs-wraper-out">
        <div class="tabs-wraper-in" v-show="!isLogged" >
          <v-tabs v-model="activeTab" class="tabs" centered grow height="60px">
            <v-tab v-for="tab in tabs" :key="tab.id" :to="tab.route" exact>{{
              tab.name
            }}</v-tab>
          </v-tabs>
          <div v-if="activeTab === '/enter/login'">
            <v-col cols="12" md="9" class="mx-md-auto">
              <FormLogin :activateOtpOnPage="true"/> 
            </v-col>
          </div>
          <div v-if="activeTab === '/enter/signup'">
     
            <FormSignup :page="'4'"  :redirect-back="true"  class="pt-4" :activateOtpOnPage="true"/>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

import FormSignup from '@/components/NavigationMenu/UserMenu/FormSignup';
import FormLogin from '@/components/NavigationMenu/UserMenu/FormLogin.vue'
import DropDivider from '@/components/DropDownMenu/DropDivider'
import CurrentUser from '@/components/mixins/CurrentUser'

export default {
  layout: 'innerPage',
  name: 'enterPage',
    mixins: [CurrentUser],
  scrollToTop: false,
  components: {
    FormSignup,
    FormLogin,
    DropDivider,
  },
  props: {
    id: {
      type: String,
      required: false,
      default: 'login',
    },
  },

  head() {
    return {
      title: 'דרושים | חיפוש עבודה חינם | אתר דרושים | דרושים IL',
      link: [
        { rel: 'canonical', href: 'https://www.drushim.co.il/enter.aspx' },
      ],
      meta: [
        {
          name: 'author',
          content: 'דרושים IL',
          hid: 'author',
        },
        {
          name: 'copyright',
          content: 'דרושים IL, 2014',
          hid: 'COPYRIGHT',
        },
        {
          name: 'Author',
          content: 'דרושים - https://www.drushim.co.il/',
          hid: 'AUTHOR',
        },
        {
          name: 'Generator',
          content: 'דרושים - https://www.drushim.co.il/',
          hid: 'GENERATOR',
        },
        {
          name: 'keywords',
          content:
            'דרושים, אתר דרושים, עבודה, חיפוש עבודה, משרות, מודעות דרושים, דרושים הייטק, עבודה בחול, גיוס עובדים, פרסום מודעות דרושים.',
          hid: 'KEYWORDS',
        },
        {
          name: 'description',
          content:
            'דרושים IL הינו אתר דרושים האיכותי בישראל. האתר מאפשר חיפוש עבודה חינם באופן מהיר וידידותי ומכיל אלפי מודעות דרושים. בנוסף, מכיל האתר איזור דרושים הייטק.',
          hid: 'DESCRIPTION',
        },
        {
          name: 'ROBOTS',
          content: 'INDEX, FOLLOW',
          hid: 'ROBOTS',
        },
        {
          name: 'og:url',
          content: 'https://www.drushim.co.il/',
          hid: 'OG:URL',
        },
        {
          name: 'og:image',
          content: 'https://www.drushim.co.il/Images/portal_thumbnail.png',
          hid: 'OG:IMAGE',
        },
      ],
    }
  },
  created(){
      if (this.isLogged){
        this.$router.push('/')
      }
  },
  mounted(){
      if (this.isLogged){
        this.$router.push('/')
      }
  },

  data() {
    return {
      activeTab: `/enter/${this.id}`,
      tabs: [
        { id: 1, name: 'משתמש רשום', route: `/enter/login` },
        { id: 2, name: 'משתמש חדש', route: `/enter/signup` },
      ],
    }
  },

  methods: {
    changeRoute(route, tab) {
      this.$router.push(route)
      this.active = tab
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs-wraper-out {
  max-width: 600px;
}
.tabs-wraper,
.tabs-wraper-in {
  min-height: 600px;
}
</style>
